import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Link } from 'foundations-components/transitional/components/Link';
import { Media } from 'foundations-components/transitional/components/Media';
import { MediaBody } from 'foundations-components/transitional/components/MediaBody';
import { MediaLeft } from 'foundations-components/transitional/components/MediaLeft';
import { MediaRight } from 'foundations-components/transitional/components/MediaRight';
import { Small } from 'foundations-components/transitional/components/Small';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { useCallback, useContext, useMemo } from 'react';
import { ACTIONS, SCREENS } from '../../constants/Tracking';
import { AppContext } from '../../contexts/app/context';
import { ContactsPropsContext } from '../../contexts/contacts/PropsContext';
import { ContactsContext } from '../../contexts/contacts/context';
import { ContactsAvatarWrapper, ContactsNameWrapper } from '../../styles/contacts';
import Avatar from '../common/Avatar';
import { View } from 'foundations-components/components/View';
import { ContactsIcon } from 'foundations-assets/icons/components/ContactsIcon';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { ObjectAssociationsIcon } from 'foundations-assets/icons/components/ObjectAssociationsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function DraftAttendeeRow({
  attendee: {
    firstname,
    lastname,
    email,
    contactId
  },
  setContactToDissociate,
  openPreviewModal,
  getAssociations,
  openAssociationModal
}) {
  const {
    usageTracker,
    callObjectTitle,
    callObjectId,
    apiWrapper,
    portalId
  } = useContext(ContactsPropsContext);
  const {
    associations,
    associationsLoading,
    contactsActions
  } = useContext(ContactsContext);
  const {
    appName
  } = useContext(AppContext);
  const onClickAssociate = useCallback(() => {
    if (contactId) {
      usageTracker.trackInteraction(Object.assign({
        screen: SCREENS.participants
      }, ACTIONS.participants.clickAssociate));
      contactsActions.associateObject({
        objectId: contactId,
        cb: getAssociations,
        callObjectId
      });
    }
  }, [contactId, usageTracker, getAssociations, callObjectId, contactsActions]);
  const onNameClick = useCallback(() => {
    if (contactId) {
      openPreviewModal(contactId.toString());
    }
  }, [openPreviewModal, contactId]);
  const createContactHanlder = useCallback(() => {
    openAssociationModal();
    contactsActions.setNewContactEmail(email);
    usageTracker.trackInteraction(Object.assign({
      screen: SCREENS.participants
    }, ACTIONS.participants.clickCreate));
  }, [email, usageTracker, openAssociationModal, contactsActions]);
  const removeAssociationHandler = useCallback(() => {
    setContactToDissociate({
      contactId: contactId || 0,
      firstname: firstname || '',
      lastname: lastname || ''
    });
    usageTracker.trackInteraction(Object.assign({
      screen: SCREENS.participants
    }, ACTIONS.participants.clickDissociate));
  }, [contactId, firstname, lastname, setContactToDissociate, usageTracker]);
  const ctaButton = useMemo(() => {
    if (contactId) {
      const existingAssociation = associations.find(item => +item.id === contactId);
      if (existingAssociation) {
        return /*#__PURE__*/_jsx(IconButton, {
          use: "tertiary-light",
          onClick: removeAssociationHandler,
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "contactList.guest.remove",
            options: {
              callObjectTitle
            }
          }),
          borderRadius: "200",
          size: "xs",
          "data-test-id": `${appName}-guest-dissociate-button`,
          children: /*#__PURE__*/_jsx(DeleteIcon, {})
        });
      }
      return /*#__PURE__*/_jsxs(Button, {
        use: "tertiary-light",
        onClick: onClickAssociate,
        responsive: false,
        disabled: associationsLoading,
        size: "xs",
        borderRadius: "200",
        "data-test-id": `${appName}-guest-associate-button`,
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "contactList.guest.associate"
        }), /*#__PURE__*/_jsx(ObjectAssociationsIcon, {})]
      });
    }
    return /*#__PURE__*/_jsxs(Button, {
      use: "tertiary-light",
      onClick: createContactHanlder,
      responsive: false,
      disabled: associationsLoading,
      size: "xs",
      borderRadius: "200",
      "data-test-id": `${appName}-guest-create-button`,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "contactList.guest.create"
      }), /*#__PURE__*/_jsx(ContactsIcon, {})]
    });
  }, [contactId, associationsLoading, associations, onClickAssociate, createContactHanlder, removeAssociationHandler, callObjectTitle, appName]);
  const NameWrapper = useCallback(({
    children
  }) => {
    const existingAssociation = associations.find(item => +item.id === contactId);
    if (contactId && existingAssociation) {
      return /*#__PURE__*/_jsx(ContactsNameWrapper, {
        children: /*#__PURE__*/_jsx(Link, {
          "data-test-id": `${appName}-guest-contact-name-button`,
          onClick: onNameClick,
          children: children
        })
      });
    }
    return /*#__PURE__*/_jsx(ContactsNameWrapper, {
      children: children
    });
  }, [onNameClick, associations, contactId, appName]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Media, {
      align: "center",
      spacing: "medium",
      "data-test-id": `${appName}-guest-card`,
      paddingBlock: "200",
      children: [/*#__PURE__*/_jsx(MediaLeft, {
        children: /*#__PURE__*/_jsx(ContactsAvatarWrapper, {
          children: /*#__PURE__*/_jsx(Avatar, Object.assign({}, Object.assign({}, contactId && {
            email,
            vid: Number(contactId)
          }, {
            type: 'contact',
            size: 'responsive',
            getAvatarsApi: apiWrapper.getAvatars,
            portalId
          })))
        })
      }), /*#__PURE__*/_jsxs(MediaBody, {
        children: [' ', /*#__PURE__*/_jsxs(View, {
          padding: "0",
          margin: "0",
          as: "div",
          children: [/*#__PURE__*/_jsx(NameWrapper, {
            children: /*#__PURE__*/_jsx(TruncateString, {
              useFlex: true,
              children: firstname || lastname ? `${firstname || ''} ${lastname || ''}` : email.split('@')[0]
            })
          }), /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: /*#__PURE__*/_jsx(TruncateString, {
              useFlex: true,
              children: email
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(MediaRight, {
        children: ctaButton
      })]
    }, email)
  });
}
export default DraftAttendeeRow;